import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MobileTabItemsRegistry from '../../common/MobileTabItemsRegistry';
import ForumMobileTabSessionItem from '../components/ForumMobileTabSessionItem';
import ForumNewDiscussionItem from '../components/ForumNewDiscussionItem';
import ForumSearchTabItem from '../components/ForumSearchTabItem';

/**
 * Extends the base `MobileTabItemsRegistry` to safely add forum-specific logic.
 *
 * Its primary purpose is to assign `forumComponent` handlers or add new items
 * that depend on components imported from the `flarum/forum` application (e.g. `SessionDropdown`).
 *
 * These forum-specific imports cannot be placed in `common/MobileTabItemsRegistry`
 * because that file is also loaded by the admin panel,
 * which would cause a crash as the imports are not available in the admin context.
 */
export default class MobileTabItemsRegistryForum extends MobileTabItemsRegistry {
  items() {
    const items = super.items();
    items.setContent('new_discussion', _objectSpread(_objectSpread({}, items.get('new_discussion')), {}, {
      forumComponent: ForumNewDiscussionItem
    }));
    items.setContent('session', _objectSpread(_objectSpread({}, items.get('session')), {}, {
      forumComponent: ForumMobileTabSessionItem
    }));
    items.setContent('search', _objectSpread(_objectSpread({}, items.get('search')), {}, {
      forumComponent: ForumSearchTabItem
    }));
    return items;
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/data/MobileTabItemsRegistryForum', MobileTabItemsRegistryForum);